export const CIRCULAR_UPDATES = "CIRCULAR_UPDATES";
export const CIRCULAR_UPDATES_ERROR = "CIRCULAR_UPDATES_ERROR";
export const CIRCULAR_UPDATES_HIDE_ERROR = "CIRCULAR_UPDATES_HIDE_ERROR";
export const CIRCULAR_UPDATES_START_LOADER = "CIRCULAR_UPDATES_START_LOADER";
export const CIRCULAR_UPDATES_STOP_LOADER = "CIRCULAR_UPDATES_STOP_LOADER";
